import { render, staticRenderFns } from "./AnimalsStatus.vue?vue&type=template&id=c1b6d4ca&"
import script from "./AnimalsStatus.vue?vue&type=script&lang=js&"
export * from "./AnimalsStatus.vue?vue&type=script&lang=js&"
import style0 from "./AnimalsStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports